import Fetch from "@/fetch/index";

//State
const state = {
  company: null,

  customerFields: null,

  customerFieldsOrder: null,
};

//Getters
const getters = {
  company(state) {
    return state.company;
  },

  companyTreatmentSingular(state) {
    let ret = "Empresa";

    if (state.company) {
      ret = state.company.company_treatment;
    }

    return ret;
  },

  companyTreatmentPlural(state) {
    let ret = "Empresas";

    if (state.company) {
      ret = state.company.company_treatment_plural;
    }

    return ret;
  },

  customerTreatmentSingular(state) {
    let ret = "Cliente";

    if (state.company) {
      ret = state.company.customer_treatment;
    }

    return ret;
  },

  customerTreatmentPlural(state) {
    let ret = "Clientes";

    if (state.company) {
      ret = state.company.customer_treatment_plural;
    }

    return ret;
  },

  customerFieldsOrder(state) {
    return state.customerFieldsOrder;
  },

  planIdentifier(state) {
    return state.company?.plan_identifier || null;
  },

  planName(state) {
    return state.company?.plan_name || null;
  },

  planCustomersLimit(state) {
    return state.company?.plan_customers_limit || null;
  },

  customersCount(state) {
    return state.company?.customers_count || 0;
  },

  isFreePlan(state) {
    return state.company?.plan_identifier === "free";
  },

  inTrial(state) {
    return !!state.company?.in_trial;
  },

  trialDaysLeft(state) {
    return state.company?.trial_days_left || 0;
  },

  effectiveCustomersLimit(state) {
    return state.company?.effective_customers_limit || null;
  },

  pendingInvoiceUrl(state) {
    return state.company?.pending_invoice_url || null;
  },
};

// In-flight GET /companies/:id, shared by everyone who asks while it is running
let companyRequest = null;

//Actions
const actions = {
  loadCompany(context, options = {}) {
    // The layout and the page ask for it at the same time on load: one request serves both.
    // { force: true } after a change (plan, payment) asks again instead of joining an older request.
    if (companyRequest && !(options && options.force)) return companyRequest;
    const companyId = context.rootGetters["App/user"].company_id;

    companyRequest = Fetch.get(`/api/v1/companies/${companyId}`)
      .then((response) => {
        context.dispatch("setCompany", response.data);
        return response;
      })
      .catch((error) => {
        // Error handling - eventbus access would need to be passed from component
        console.error("Error loading company:", error);
        throw error;
      })
      .finally(() => {
        companyRequest = null;
      });
    return companyRequest;
  },

  loadCustomerFields(context) {
    // Both only need the company id, which the signed-in user already has: fetch them together.
    const companyId = context.rootGetters["App/user"].company_id;
    return Promise.all([context.dispatch("loadCompany"), Fetch.get(`/api/v1/companies/${companyId}/customer_fields`)]).then(
      ([responseCompany, responseCustomerFields]) => {
        context.commit("SET_CUSTOMER_FIELDS", responseCustomerFields.data);
        return { responseCompany, responseCustomerFields };
      },
    );
  },

  // Keeps both the company module and App/user.company in sync (used after billing changes)
  refreshCompany(context, obj) {
    context.dispatch("setCompany", obj);

    const user = context.rootGetters["App/user"];
    if (user && user.id) {
      context.dispatch("App/setUser", { ...user, company: { ...(user.company || {}), ...obj } }, { root: true });
    }
  },

  setCompany(context, obj) {
    localStorage.setItem("ordexa/company/id", obj.id);
    localStorage.setItem("ordexa/company/hash", obj.hashid);

    context.commit("SET_COMPANY", obj);

    context.commit("SET_CUSTOMER_FIELDS_ORDER", obj.customer_fields_order);
  },
};

//Mutations
const mutations = {
  SET_COMPANY(state, obj) {
    state.company = obj;
  },

  SET_CUSTOMER_FIELDS(state, obj) {
    state.customerFields = obj;
  },

  SET_CUSTOMER_FIELDS_ORDER(state, obj) {
    state.customerFieldsOrder = obj;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
